
OT.createNS('OT.Redesign.Views.Results.Pagination');

OT.Redesign.Views.Results.Pagination = Backbone.ViewManager.BaseView.extend({

    el: '#search_results_container',

    template: 'Redesign/Results/_Pagination',

    events: {
        'click .pagination-prev': 'loadPrevResults',
        'click .pagination-next': 'loadNextResults',
        'click .js-pagination-page': 'loadPageResults'
    },

    initialize: function () {
        this.pageSize = OT.Search.Data.get().Request.Size;
        this.currentIndex = OT.Search.Data.get().Request.From || 0;
        this.toggleButton();

        OT.Events.on('results:done', function () {
            OT.Search.views.pagination.toggleButton();
        });
    },

    toggleButton: function () {
        this.currentIndex = OT.Search.Data.get().Request.From || 0;
        var resultsTotal = OT.Search.Data.get().Results.TotalAvailable;

        //Hide naviagtion link if only one page exists
        if (resultsTotal <= this.pageSize) {
            $(".pagination-container").hide();
            return false;
        }

        $(".pagination-container").show();

        //Disable prev link if on first page
        if (this.currentIndex === 0) {
            $(".pagination-prev").addClass("pagination-unavailable");
        } else {
            $(".pagination-prev").removeClass("pagination-unavailable");
        }

        //Disable next link if on last page
        if (this.currentIndex + this.pageSize >= resultsTotal) {
            $(".pagination-next").addClass("pagination-unavailable");
        } else {
            $(".pagination-next").removeClass("pagination-unavailable");
        }
    },

    loadPrevResults: function (e) {
        e.preventDefault();

        this.currentIndex = OT.Search.Data.get().Request.From || 0;

        if (this.currentIndex !== 0) {
            var newIndex = Math.max(this.currentIndex - this.pageSize, 0);
            this.loadFrom(newIndex);
        }
    },

    loadNextResults: function (e) {
        e.preventDefault();

        this.currentIndex = OT.Search.Data.get().Request.From || 0;
        var totalResults = OT.Search.Data.get().Results.TotalAvailable;
        var newIndex = this.currentIndex + this.pageSize;

        if (newIndex < totalResults) {
            this.loadFrom(newIndex);
        }
    },

    loadPageResults: function (e) {
        e.preventDefault();

        var $target = $(e.currentTarget);
        var from = $target.data('from');

        if (from === -1 || $target.hasClass('pagination-current')) {
            return;
        }

        this.loadFrom(from);
    },

    getCorrelationIds: function () {
        var correlationId = $('.analytics-results-list.infinite-results-list').data('correlationid');
        var popCorrelationId = $('.analytics-results-list.pop-result-grid').data('correlationid');
        var ids = {};
        if (correlationId) {
            ids.CorrelationId = correlationId;
        }
        if (popCorrelationId) {
            ids.PopCorrelationId = popCorrelationId;
        }
        return ids;
    },

    loadFrom: function(index) {
        var correlationIds = this.getCorrelationIds();
        
        OT.Search.Params.set({
            From: index
        });

        OT.Search.Requests.Results.get({
            xhrOnlyParams: correlationIds
        });
    }
});
